import { i18n } from '@lt/localization';
import type { TourGuideItem } from './types';

import Beach from '../../../images/tour_guide_rebrand/Beach.webp';
import Toggle from '../../../images/tour_guide_rebrand/Toggle.webp';
import Plane from '../../../images/tour_guide_rebrand/Plane.webp';
import LT from '../../../images/tour_guide_rebrand/LT.webp';
import Tip from '../../../images/tour_guide_rebrand/Tip.webp';

export const ITEMS = (isHotelOnly?: boolean): TourGuideItem[] => [
  {
    image: {
      src: Beach,
      align: 'right',
    },
    title: i18n.t('howBuy.tourSelection.title'),
    text: i18n.t('howBuy.tourSelection.text'),
    buttonText: i18n.t('howBuy.tourSelection.buttonText'),
    desktopStyles: {
      width: 125,
      height: 125,
    },
  },
  {
    image: {
      src: Toggle,
      align: 'left',
    },
    title: i18n.t('howBuy.payment.title'),
    text: i18n.t('howBuy.payment.text'),
    buttonText: i18n.t('howBuy.payment.buttonText'),
    desktopStyles: {
      width: 125,
      height: 125,
    },
  },
  {
    image: {
      src: Plane,
      align: 'right',
    },
    title: i18n.t('checkout.payment.after.title'),
    text: i18n.t('checkout.payment.after.text', {
      context: isHotelOnly ? 'hotel' : 'package',
    }),
    buttonText: i18n.t('checkout.payment.after.button'),
    desktopStyles: {
      width: 125,
      height: 125,
    },
  },
  {
    image: {
      src: LT,
      align: 'left',
    },
    title: i18n.t('checkout.payment.document.title'),
    text: i18n.t('checkout.payment.document.text', {
      context: isHotelOnly ? 'hotel' : 'package',
    }),
    buttonText: i18n.t('checkout.payment.document.button'),
    desktopStyles: {
      width: 125,
      height: 125,
    },
  },
  {
    image: {
      src: Tip,
      align: 'right',
    },
    title: i18n.t('checkout.payment.support.title'),
    text: i18n.t('checkout.payment.support.text', {
      context: isHotelOnly ? 'hotel' : 'package',
    }),
    buttonText: i18n.t('checkout.payment.support.button'),
    desktopStyles: {
      width: 125,
      height: 125,
    },
  },
];
